import { Component } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { LeadershipStipendConfigService } from 'src/app/core/services/leadership-stipend-config.service';
import { UtilService } from 'src/app/core/services/util.service';

@Component({
  selector: 'app-copy-stipend-config',
  templateUrl: './copy-stipend-config.component.html',
  styleUrls: ['./copy-stipend-config.component.scss']
})
export class CopyStipendConfigComponent {

  userForm: FormGroup = new FormGroup({});
  formFields: any[] = [];
  submitting = false;

  constructor(
    public dialogRef: MatDialogRef<CopyStipendConfigComponent>,
    public configService: LeadershipStipendConfigService,
    private utilService: UtilService
  ) {
    const currentYear = new Date().getFullYear();
    const options: any[] = [];
    for (let i = -1; i <= 2; i++) {
      const y = (currentYear + i).toString();
      options.push({ label: y, value: y });
    }
    this.formFields = [
      { name: 'fromYear', label: 'From Year', type: 'select', space: 1, validators: [Validators.required], options },
      { name: 'toYear', label: 'To Year', type: 'select', space: 1, validators: [Validators.required], options },
    ];
  }

  submit() {
    if (!this.userForm.valid) return;
    const fromYear = parseInt(this.userForm.value.fromYear, 10);
    const toYear = parseInt(this.userForm.value.toYear, 10);
    if (fromYear === toYear) {
      this.utilService.openToastr('error', 'From and To year must be different.');
      return;
    }

    this.submitting = true;
    // Read the source year's saved config, then write it under the target year.
    this.configService.getConfig(fromYear).subscribe({
      next: (cfg: any) => {
        this.configService.saveConfig({ ...cfg, year: toYear }).subscribe({
          next: () => {
            this.utilService.openToastr('success', `Copied configuration from ${fromYear} to ${toYear}.`);
            this.dialogRef.close(toYear);
          },
          error: () => {
            this.utilService.openToastr('error', 'Failed to save the copied configuration.');
            this.submitting = false;
          }
        });
      },
      error: () => {
        this.utilService.openToastr('error', 'Failed to load the source configuration.');
        this.submitting = false;
      }
    });
  }
}
